import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDont20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDoAndDont20"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#DoAndDont20)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M2.25 6.75a4.5 4.5 0 1 1 8.915.874 6 6 0 0 0-1.514.828l-1.59-1.59 1.545-1.545a.75.75 0 0 0-1.06-1.06L7 5.802 5.455 4.257a.75.75 0 1 0-1.06 1.06L5.94 6.862 4.394 8.408a.75.75 0 0 0 1.06 1.06L7 7.923l1.574 1.573c-.4.498-.721 1.06-.947 1.669A4.5 4.5 0 0 1 2.25 6.75m5.027 5.977q-.261.023-.527.023a6 6 0 1 1 5.977-5.477 6 6 0 1 1-5.45 5.454m1.478.523a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m7.69-1.78a.75.75 0 0 1 0 1.06l-3.552 3.553-.53.53-.53-.53-1.768-1.768a.75.75 0 0 1 1.06-1.06l1.238 1.237 3.022-3.022a.75.75 0 0 1 1.06 0"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="DoAndDont20">
                        <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconDoAndDont20);
